import PropTypes from 'prop-types';

export const unpostedGLJournalsPropType = PropTypes.shape({
  acctDescription: PropTypes.string,
  bookType: PropTypes.string,
  companyCode: PropTypes.string,
  costCenter: PropTypes.string,
  createdBy: PropTypes.string,
  createdOn: PropTypes.string,
  credit: PropTypes.number,
  currencyCode: PropTypes.string,
  debit: PropTypes.number,
  function: PropTypes.string,
  geography: PropTypes.string,
  glAccount: PropTypes.string,
  glJournalId: PropTypes.number,
  periodName: PropTypes.string,
  postedFlag: PropTypes.string,
  postedOn: PropTypes.string,
  project: PropTypes.string,
  reference: PropTypes.string,
  taxEntryId: PropTypes.number,
  tradingPartner: PropTypes.string,
  updatedBy: PropTypes.string,
  updatedOn: PropTypes.string,
});

const SubledgerUserTaxEntriesPropType = PropTypes.shape({
  amount: PropTypes.number,
  batchId: PropTypes.string,
  bookType: PropTypes.string,
  businessUnit: PropTypes.string,
  ccDescription: PropTypes.string,
  companyCode: PropTypes.string,
  connName: PropTypes.string,
  countryTaxType: PropTypes.string,
  countryTaxTypeDesc: PropTypes.string,
  createdOn: PropTypes.string,
  createdSso: PropTypes.string,
  currencyCode: PropTypes.string,
  description: PropTypes.string,
  legalEnttiy: PropTypes.string,
  method: PropTypes.string,
  periodName: PropTypes.string,
  postedFlag: PropTypes.string,
  preparerName: PropTypes.string,
  reviewComment: PropTypes.string,
  reviewedFlag: PropTypes.string,
  reviewedOn: PropTypes.string,
  reviewedSso: PropTypes.string,
  reviewerName: PropTypes.string,
  sso: PropTypes.string,
  taxEntryActivity: PropTypes.string,
  taxEntryActivityDesc: PropTypes.string,
  taxEntryId: PropTypes.number,
  taxEntryType: PropTypes.string,
  taxEntryTypeDesc: PropTypes.string,
  taxYear: PropTypes.string,
  updatedOn: PropTypes.string,
});

export const pendingSubledgerUserTaxEntriesPropType = SubledgerUserTaxEntriesPropType;
export const declinedSubledgerUserTaxEntriesPropType = SubledgerUserTaxEntriesPropType;
export const approvedSubledgerUserTaxEntriesPropType = SubledgerUserTaxEntriesPropType;

export const notificationsPropType = PropTypes.shape({
  unpostedGLJournals: PropTypes.arrayOf(unpostedGLJournalsPropType),
  pendingSubledgerUserTaxEntries: PropTypes.arrayOf(pendingSubledgerUserTaxEntriesPropType),
  declinedSubledgerUserTaxEntries: PropTypes.arrayOf(declinedSubledgerUserTaxEntriesPropType),
  approvedSubledgerUserTaxEntries: PropTypes.arrayOf(approvedSubledgerUserTaxEntriesPropType),
});

